export const VARIANTS_KINDS = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  success: 'success',
  danger: 'danger',
  warning: 'warning',
  grouped: 'grouped'
  }

export type VARIANTS_TYPES = keyof typeof VARIANTS_KINDS

export const BADGE_KINDS = {
  gray: 'gray',
  red: 'red',
  yellow: 'yellow',
  green: 'green',
  blue: 'blue',
  purple: 'purple',
  white: 'white'
};

export type BADGE_TYPES = keyof typeof BADGE_KINDS

export const TEXTLINK_VARIANTS_KINDS = {
  default: 'default',
  danger: 'danger',
  warning: 'warning',
  success: 'success'
}

export type TEXTLINK_VARIANTS_TYPES = keyof typeof TEXTLINK_VARIANTS_KINDS

export const SEARCHINPUTBTN_VARIANTS_KINDS = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
}

export type SEARCHINPUTBTN_VARIANTS_TYPES = keyof typeof SEARCHINPUTBTN_VARIANTS_KINDS

export const INDICATORS_COLORS_KINDS = {
  'gray': 'gray',
  'white': 'white',
  'red': 'red',
  'yellow': 'yellow',
  'green': 'green',
  'blue': 'blue'
}

export type INDICATORS_COLORS_TYPES = keyof typeof INDICATORS_COLORS_KINDS

export const CLOSEBUTTON_COLORS_KINDS = {
  'gray': 'gray',
  'white': 'white',
  'red': 'red',
  'yellow': 'yellow',
  'green': 'green',
  'blue': 'blue'
}

export type CLOSEBUTTON_COLORS_TYPES = keyof typeof INDICATORS_COLORS_KINDS

export const SNAPLINK_FONT_KINDS = {
  'bold': 'bold',
  'semibold': 'semibold',
  'medium': 'medium',
}

export type SNAPLINK_FONT_TYPES = keyof typeof SNAPLINK_FONT_KINDS
